import React, {
  useState,
  useEffect
} from 'react';

import {SiteLinks} from '../../general';

function ThesisWritingPageInfo() {
  return (<SiteLinks screen="s2_student_thesis" />);
}

export {ThesisWritingPageInfo};